import { createContext, useEffect, useState } from "react";
import { CommerceInfo } from "../utilities/servicesTrackWeb";
import instanceCommerce from "../config/instanceCommerce.js";
import { Navigate } from "react-router-dom";

const LoginContext = createContext();
const LoginProvider = ({ children }) => {
  const [isLogin, setIsLogin] = useState(window.localStorage.getItem("login"));
  const [changeMetrics, setChangeMetrics] = useState(false);
  const [allMetrics, setAllMetrics] = useState("");
  const [search, setSearch] = useState(false);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [selectedBranch, setSelectedBranch] = useState("");

  const [modal, setModal] = useState(false);

  const [token, setToken] = useState(window.localStorage.getItem("token"));

  const [dataCommerce, setDataCommerce] = useState(
    window.localStorage.getItem("commerce")
  );
  const [infoCommerce, setInfoCommerce] = useState(
    JSON.parse(window.localStorage.getItem("commerce-info"))
  );

  // TTL Token LogIn
  useEffect(() => {  

    let timestamp = new Date().getTime();
    const timestampAnterior = parseInt(localStorage.getItem("timeStamp"));    
    const diferenciaHoras = (timestamp - timestampAnterior) / (1000 * 60 * 60); // Calcula la diferencia en horas

    if (diferenciaHoras >= 24) {
      finishSession(); // Ejecuta la función finishSession() si la diferencia es mayor o igual a 24 horas
    }
    
  }, []);

  const finishSession = () => {
    window.localStorage.removeItem("login");
    window.localStorage.removeItem("commerce");
    window.localStorage.removeItem("token");
    window.localStorage.removeItem("commerce-info");
    window.localStorage.removeItem("metrics");
    localStorage.clear();
    setIsLogin(false);
  };
  useEffect(() => {
    const fetchData = async () => {
      if (dataCommerce && token && isLogin) {
        const data = await CommerceInfo(dataCommerce, token);
        setInfoCommerce(data);
        window.localStorage.setItem("commerce-info", JSON.stringify(data));
      }
    };
    fetchData();
  }, [dataCommerce, token, isLogin]);

  useEffect(() => {
    const fetchData = async () => {
      if (isLogin && dataCommerce && token) {
        let url =  `/api/DownloadGetShopActivity?nro_comercio=${dataCommerce}`;
        if (search) {
          if (selectedBranch) {
            url += `&id_sucursal=${selectedBranch}`;
          }
          if (startDate && endDate){
            url = `/api/DownloadGetShopActivityByDate?nro_comercio=${dataCommerce}&desde=${startDate}&hasta=${endDate}`
            if (selectedBranch){
              url += `&id_sucursal=${selectedBranch}`
            }
          }
        }
        try {
          const data = await instanceCommerce({
            url: url,
            method: "GET",
            headers: {
              Authorization: "Bearer " + token,
            },
          }).then((res) => {
            return res.data;
          });
          setAllMetrics(data.data);
          return data;
        } catch (error) {
          console.log(error)
          return false;
        }
      }
    };
    fetchData();
  }, [isLogin, dataCommerce, token, startDate, endDate, search, changeMetrics, selectedBranch]);

  const handleToken = (commerceNumber, id) => {
    try {
      setDataCommerce(commerceNumber);
      setToken(id);
      window.localStorage.setItem("commerce", commerceNumber);
      window.localStorage.setItem("token", id);
      const timestamp = new Date().getTime();
      window.localStorage.setItem("timeStamp", timestamp);
    } catch (error) {
      return <Navigate to="/login" replace={true} />;
    }
  };

  const handleLogin = (login) => {
    try {
      setIsLogin(login);
      window.localStorage.setItem("login", login);
    } catch (error) {
      return false;
    }
  };

  setTimeout(() => {
    window.localStorage.removeItem("login");
    window.localStorage.removeItem("commerce");
    window.localStorage.removeItem("token");
    window.localStorage.removeItem("commerce-info");
    window.localStorage.removeItem("metrics");
    finishSession();
    if (!isLogin) {
      return <Navigate to="/login" replace={true} />;
    }
  }, 23 * 60 * 60 * 1000);

  const handleModalClick = () => {
    setModal(!modal);
  };

  useEffect(() => {
    if (!token) {
      setIsLogin(false);
      window.localStorage.setItem("login", isLogin);
    }
  }, [isLogin, token]);

  return (
    <LoginContext.Provider
      value={{
        handleLogin,
        handleToken,
        isLogin,
        infoCommerce,
        dataCommerce,
        token,
        allMetrics,
        setAllMetrics,
        setSearch,
        setStartDate,
        setEndDate,
        setSelectedBranch,
        selectedBranch,
        startDate,
        endDate,
        search,
        finishSession,
        setChangeMetrics,
        changeMetrics,
        handleModalClick,
        modal,
      }}
    >
      {children}
    </LoginContext.Provider>
  );
};

export { LoginProvider };

export default LoginContext;
